// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"d45e2fb4","187":"d7e21d16","324":"ae7dbf3d","499":"bbfa705a","529":"3c40e671","616":"de54d830","717":"d11f20a5","816":"9b545083","820":"477244a5","934":"df84ef44","972":"58de6431"}[chunkId] + ".chunk.js";
};